class MutaeBagConsent extends HTMLElement {
  #observer;
  #root;

  connectedCallback() {
    this.#root = this.closest('cart-items-component') || this.closest('.cart-page') || document;
    this.addEventListener('change', this.#sync);
    document.addEventListener('submit', this.#validate, true);
    this.#observer = new MutationObserver(this.#sync);
    this.#observer.observe(this.#root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });
    this.#sync();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.removeEventListener('change', this.#sync);
    document.removeEventListener('submit', this.#validate, true);
  }

  #sync = () => {
    const checkbox = this.querySelector('input');
    const button = this.#root.querySelector('button[name="checkout"]');
    if (!checkbox || !button) return;
    const busy = Boolean(this.#root.classList?.contains('cart-items-disabled'));
    const disabled = !checkbox.checked || busy;
    if (button.disabled !== disabled) button.disabled = disabled;
  };

  #validate = (event) => {
    const checkbox = this.querySelector('input');
    if (!checkbox || event.target !== checkbox.form || checkbox.checked) return;
    event.preventDefault();
    checkbox.reportValidity();
    checkbox.focus();
  };
}

if (!customElements.get('mutae-bag-consent')) {
  customElements.define('mutae-bag-consent', MutaeBagConsent);
}
